
import { SidebarMenuItem as BaseSidebarMenuItem, SidebarMenuButton } from "@/components/ui/sidebar";
import { SidebarMenuItemProps } from "./types";

export const SidebarMenuItem = ({ title, icon, onClick, isActive }: SidebarMenuItemProps) => {
  return (
    <BaseSidebarMenuItem>
      <SidebarMenuButton
        asChild
        className={isActive ? "bg-accent" : ""}
      >
        <button
          onClick={onClick}
          className="flex items-center gap-2 w-full px-2 py-1.5 rounded-sm hover:bg-accent"
        >
          {icon}
          <span>{title}</span>
        </button>
      </SidebarMenuButton>
    </BaseSidebarMenuItem>
  );
};
